import { getMobileAppVersion as getAppVersion } from '@myrealtrip/browser';

export function getMobileAppVersion(userAgent: string) {
  return getAppVersion({ userAgent, appType: 'traveler' }) || [];
}

export default getMobileAppVersion;
